
export default {
  methods: {
    toggleCategorySideMenu () {
      // TODO: refactor to use some flag in store and v-if client-only
      document.querySelectorAll('body')[0].classList.toggle('category-menu-active')
      document.querySelectorAll('.mobile-nav-button')[0].classList.toggle('mobile-nav-button-active')
    }
  }
}
